import React from 'react';
import { Button, Popover, Slider } from 'antd';
import {
  PlayCircleOutlined,
  PauseCircleOutlined,
  SoundOutlined,
  FullscreenOutlined,
  RetweetOutlined,
} from '@ant-design/icons';
import styles from './VideoPlayer.module.scss';

interface VideoControlsProps {
  isPlaying: boolean;
  volume: number;
  currentTime: number;
  duration: number;
  onPlayPause: () => void;
  onVolumeChange: (value: number) => void;
  onFullScreen: () => void;
  isLooping?: boolean;
  onToggleLoop?: () => void;
}

const VideoControls: React.FC<VideoControlsProps> = ({
  isPlaying,
  volume,
  currentTime,
  duration,
  onPlayPause,
  onVolumeChange,
  onFullScreen,
  isLooping,
  onToggleLoop,
}) => {
  const formatTime = (time: number | undefined) => {
    if (time === undefined || isNaN(time) || time === 0) return '00:00';
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  return (
    <div className={styles.bottomControls}>
      <Button
        style={{ width: 24, height: 24 }}
        className={styles.controlButton}
        icon={isPlaying ? <PauseCircleOutlined /> : <PlayCircleOutlined />}
        onClick={onPlayPause}
      />
      <span className={styles.timeDisplay}>
        {formatTime(currentTime)} / {formatTime(duration)}
      </span>
      <div className={styles.rightControls}>
        <Button
          style={{ width: 24, height: 24, color: isLooping ? 'var(--app-accent-color)' : undefined }}
          className={styles.controlButton}
          icon={<RetweetOutlined />}
          onClick={onToggleLoop}
          title={isLooping ? 'Disable Loop' : 'Enable Loop'}
        />
        <Popover
          content={
            <Slider
              style={{ height: 100 }}
              vertical
              min={0}
              max={1}
              step={0.01}
              value={volume}
              onChange={onVolumeChange}
            />
          }
          trigger="click"
        >
          <Button style={{ width: 24, height: 24 }} className={styles.controlButton} icon={<SoundOutlined />} />
        </Popover>
        <Button style={{ width: 24, height: 24 }} className={styles.controlButton} icon={<FullscreenOutlined />} onClick={onFullScreen}/>
      </div>
    </div>
  );
};

export default VideoControls; 